//react and redux hooks
import { useMediaQuery } from "react-responsive";

//styles
import { BackScreenDiv, ContentDiv, ScreenDiv } from "../../styles/styles";

//components
import LottieLoader from "./lottieLoader";
import { useTranslation } from "react-i18next";

const Loader = () => {

    const isDesktop =useMediaQuery({minWidth: '821px'});
    const { t } = useTranslation(['common']);
    
    return (
        <>        
            <ScreenDiv noAccount={isDesktop} height="100%" justifyContent="center" justifyContentMobile="center" justifyContentTablet="center">
            <ContentDiv justifyContentMobile="center" alignItemsMobile="center" justifyContentDesktop="center" alignItemsDesktop="center" height="fit-content">                                                                            
                    <LottieLoader width={100} height={100} />
                    <p>{t('loading')}</p>
                </ContentDiv>
            </ScreenDiv>
            <BackScreenDiv grayImage/>
        </>
    )
}

export default Loader;